export default __webpack_public_path__ + "static/media/qatar2022.23edeb96.png";